import { render, staticRenderFns } from "./evaluateDetails.vue?vue&type=template&id=38de659e&scoped=true&"
import script from "./evaluateDetails.vue?vue&type=script&lang=js&"
export * from "./evaluateDetails.vue?vue&type=script&lang=js&"
import style0 from "./evaluateDetails.vue?vue&type=style&index=0&id=38de659e&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38de659e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\svn\\家用后台\\branches\\20240430-1.5.0\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38de659e')) {
      api.createRecord('38de659e', component.options)
    } else {
      api.reload('38de659e', component.options)
    }
    module.hot.accept("./evaluateDetails.vue?vue&type=template&id=38de659e&scoped=true&", function () {
      api.rerender('38de659e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/msg/evaluateDetails.vue"
export default component.exports